/* Review-Highlights Karussell im Collection-Hero.
   Verhalten + Controls (Autoplay, Pause/Play, Pfeile, Dots) kommen aus
   initReviewsHighlightsCarousel in utils.js. */
(function () {
  "use strict";

  function init() {
    initReviewsHighlightsCarousel({
      sectionSelector: ".collection-hero-reviews[data-section-id]",
    });
  }

  // Initialisiert, sobald initReviewsHighlightsCarousel verfügbar ist.
  function start() {
    if (typeof initReviewsHighlightsCarousel === "function") {
      init();
    } else {
      window.addEventListener("utils-js-loaded", init, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
